export const Typography = {
  "heading":  {
    "heading-large":  {
      "6xl":  {
        "fontSize":  120,
        "fontFamily":  "'DM Serif Display', serif",
        "fontWeight":  400,
        "lineHeight":  "100%",
        "textDecoration":  "NONE"
      },
      "5xl":  {
        "fontSize":  86,
        "fontFamily":  "'DM Serif Display', serif",
        "fontWeight":  400,
        "lineHeight":  "100%",
        "textDecoration":  "NONE"
      },
      "4xl":  {
        "fontSize":  64,
        "fontFamily":  "'DM Serif Display', serif",
        "fontWeight":  400,
        "lineHeight":  "120%",
        "textDecoration":  "NONE"
      },
      "3xl":  {
        "fontSize":  48,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  600,
        "lineHeight":  "125%",
        "textDecoration":  "NONE"
      },
      "2xl":  {
        "fontSize":  36,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  600,
        "lineHeight":  "125%",
        "textDecoration":  "NONE"
      },
      "xl":  {
        "fontSize":  28,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  600,
        "lineHeight":  "125%",
        "textDecoration":  "NONE"
      },
      "lg":  {
        "fontSize":  24,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  600,
        "lineHeight":  "150%",
        "fontStyle": "normal",
        "textDecoration":  "NONE"
      },
      "md":  {
        "fontSize":  20,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  600,
        "lineHeight":  "150%",
        "fontStyle": "normal",
        "textDecoration":  "NONE"
      },
      "sm":  {
        "fontSize":  16,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  400,
        "lineHeight":  "150%",
        "fontStyle": "normal",
        "textDecoration":  "NONE"
      },
      "xs":  {
        "fontSize":  14,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  400,
        "lineHeight":  "150%",
        "fontStyle": "normal",
        "textDecoration":  "NONE"
      }
    },
  },
  "text":  {
    "xs":  {
      "font-normal":  {
        "fontSize":  12,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "300",
        "lineHeight":  "18px",
        "textDecoration":  "NONE",
        
      },
      "font-medium":  {
        "fontSize":  12,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "300",
        "lineHeight":  "18px",
        "textDecoration":  "NONE"
      },
      "font-semibold":  {
        "fontSize":  12,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "300",
        "lineHeight":  "18px",
        "textDecoration":  "NONE"
      }
    },
    "sm":  {
      "font-normal":  {
        "fontSize":  14,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "21px",
        
        "textDecoration":  "NONE"
      },
      "font-medium":  {
        "fontSize":  14,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "21px",
        "textDecoration":  "NONE"
      },
      "font-semibold":  {
        "fontSize":  14,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "21px",
      },
    },
    "md":  {
      "font-normal":  {
        "fontSize":  16,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "24px",
        "textDecoration":  "NONE"
      },
      "font-medium":  {
        "fontSize":  16,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "500",
        "lineHeight":  "24px",
        "textDecoration":  "NONE"
      },
      
      "font-semibold":  {
        "fontSize":  16,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "600",
        "lineHeight":  "24px",
        "textDecoration":  "NONE"
      },
    },
    "lg":  {
      "font-normal":  {
        "fontSize":  18,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "27px",
        "textDecoration":  "NONE"
      },
      "font-medium":  {
        "fontSize":  18,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "500",
        "lineHeight":  "27px",
        "textDecoration":  "NONE"
      },
      "font-semibold":  {
        "fontSize":  18,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "600",
        "lineHeight":  "27px",
        "textDecoration":  "NONE"
      },
    },
    "xl":  {
      "font-normal":  {
        "fontSize":  20,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "130%",
        
        "textDecoration":  "NONE"
      },
      "font-medium":  {
        "fontSize":  20,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "500",
        "lineHeight":  "30px",
        "textDecoration":  "NONE"
      },
      "font-semibold":  {
        "fontSize":  20,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "600",
        "lineHeight":  "30px",
        "textDecoration":  "NONE"
      }
    },
    "2xl":  {
      "font-normal":  {
        "fontSize":  24,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "36px",
        
        "textDecoration":  "NONE"
      },
      "font-medium":  {
        "fontSize":  24,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "500",
        "lineHeight":  "36px",
        "textDecoration":  "NONE"
      },
      "font-semibold":  {
        "fontSize":  24,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "600",
        "lineHeight":  "36px",
        "textDecoration":  "NONE"
      }
    },
    "3xl":  {
      "font-normal":  {
        "fontSize":  30,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "45px",
        
        "textDecoration":  "NONE"
      },
      "font-medium":  {
        "fontSize":  30,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "500",
        "lineHeight":  "45px",
        "textDecoration":  "NONE"
      },
      "font-semibold":  {
        "fontSize":  30,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "600",
        "lineHeight":  "45px",
        "textDecoration":  "NONE"
      }
    },
    "4xl":  {
      "font-normal":  {
        "fontSize":  36,
       "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "150%",
       
        "textDecoration":  "NONE"
      },
      "font-medium":  {
        "fontSize":  36,
       "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "500",
        "lineHeight":  "150%",
        "textDecoration":  "NONE"
      },
      "font-semibold":  {
        "fontSize":  36,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "600",
        "lineHeight":  "150%",
        "textDecoration":  "NONE"
      }
    },
    "5xl":  {
      "font-normal":  {
        "fontSize":  48,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "400",
        "lineHeight":  "150%",
        
        "textDecoration":  "NONE"
      },
      "font-medium":  {
        "fontSize":  48,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "500",
        "lineHeight":  "150%",
        "textDecoration":  "NONE"
      },
      "font-semibold":  {
        "fontSize":  48,
        "fontFamily":  '"DM Sans", sans-serif',
        "fontWeight":  "600",
        "lineHeight":  "125%",
        "textDecoration":  "NONE"
      }
    }
  }
};